import { useNavigate } from 'react-router-dom';
import { useOTPAuth } from '../hooks/useOTPAuth';

interface ChatHeaderProps {
  onMenuClick?: () => void;
  showMenuButton?: boolean;
}

export const ChatHeader = ({ onMenuClick, showMenuButton = false }: ChatHeaderProps) => {
  const navigate = useNavigate();
  const { isAuthenticated, isAnonymous } = useOTPAuth();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleSignup = () => {
    navigate('/promotions/welcome');
  };

  // Hide login/signup buttons when user is authenticated (and not anonymous)
  const showAuthButtons = !isAuthenticated || isAnonymous;

  return (
    <header className="bg-neutral-white dark:bg-neutral-black border-b border-neutral-light-gray dark:border-neutral-dark-gray px-6 py-4">
      <div className="flex items-center justify-between w-full max-w-7xl mx-auto">
        <div className="flex items-center gap-4">
          {showMenuButton && (
            <button
              onClick={onMenuClick}
              className="p-2 text-neutral-black dark:text-neutral-white hover:bg-neutral-light-gray dark:hover:bg-neutral-dark-gray rounded-lg transition-colors"
              aria-label="Open menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}
          <h1 className="text-2xl font-semibold text-neutral-black dark:text-neutral-white tracking-tight">
            ChatHTL
          </h1>
        </div>
        {showAuthButtons && (
          <div className="flex items-center gap-3">
            <button
              onClick={handleLogin}
              className="px-5 py-2 text-sm font-medium text-neutral-black dark:text-neutral-white bg-neutral-white dark:bg-neutral-black border border-neutral-medium-gray dark:border-neutral-dark-gray rounded-full hover:bg-neutral-light-gray dark:hover:bg-neutral-dark-gray transition-colors"
            >
              Login
            </button>
            <button
              onClick={handleSignup}
              className="px-5 py-2 text-sm font-medium text-neutral-white bg-brand-teal hover:bg-brand-teal-hover rounded-full transition-colors shadow-sm"
            >
              Sign up for free
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
